<template>
  <div
    class="content-view flex-h"
    :style="{
      position: 'absolute',
      top: `${offsetTop}px`,
      left: `${offsetLeft}px`,
      zIndex: '90001'
    }"
  >
    <div class="btn-picker-choose">
      <div class="c-f" style="padding-left: 48px;">待提订单</div>
    </div>
    <div class="pop-view">
      <img class="pop-view-bg" src="@/assets/guide/bg-left.png" />
      <div class="pop-view-top flex-h">
        <img class="pop-view-top-img" src="@/assets/guide/step-two.png" style="width: 100px" />
        <div class="m-l20">
          <div class="c-3 f-17 f-b m-t10">在这看【商家配送订单】</div>
          <div class="c-9 f-13 m-t15">要记得送货哦</div>
        </div>
      </div>
      <div class="pop-view-btn flex-h">
        <el-button class="m-r15" type="text" @click="looklook(false)"
          ><span class="next c-6 f-15">下次再说</span></el-button
        >
        <el-button
          style="width: 88px; height: 38px; line-height: 13px"
          class=""
          type="primary"
          @click="looklook(true)"
          ><span class="">去看看</span></el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { GuideKey } from './code'

export default {
  components: {},
  computed: {},
  data() {
    return {
      GuideKey,
      offsetTop: 0,
      offsetLeft: 0
    }
  },
  mounted() {
    this.resizeListener()
    window.addEventListener('resize', this.resizeListener)
  },
  methods: {
    resizeListener() {
      let btnSetting = document.getElementById('/picker/choose')
      if (btnSetting === null) return
      let { top, left } = btnSetting.getBoundingClientRect()
      this.offsetLeft = left < 0 ? 0 : left
      // 提示区域超出视窗后，定位相对于视窗底部
      const clientHeight = document.body.clientHeight
      if (top > clientHeight - 200) {
        this.offsetTop = clientHeight - 200
      } else {
        this.offsetTop = top
      }
    },
    looklook(is) {
      this.$emit('editGuide', GuideKey.two)
      if (is) {
        this.$router.push('/picker/choose')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.content-view {
  color: #ffffff;
  .btn-picker-choose {
    width: 185px;
    height: 44px;
    line-height: 44px;
    background-color: #444444;
    font-size: 13px;
  }
  .pop-view {
    transform: translate(-185px, 34px);
    .pop-view-bg {
      width: 430px;
      position: absolute;
      left: 20px;
      top: 10px;
    }
    .pop-view-top {
      transform: translate(48px, 40px);
    }
    .pop-view-btn {
      position: absolute;
      right: -111px;
      bottom: -91px;
      .next {
        &:hover {
          color: #333;
        }
      }
    }
  }
}
</style>
